import React, {Component} from 'react';
import './EmptyMessage.css';

class EmptyMessage extends Component {
	render() {
		return (
			<div className={`EmptyMessage ${this.props.extraClass || ''}`} style={this.props.style}>
				{this.props.children}
			</div>
		);
	}
}

export default EmptyMessage;



// WEBPACK FOOTER //
// ./src/widgets/EmptyMessage.js